import Vue from 'vue'
import Vuex from 'vuex'

import { auth } from './store/auth.module'
import { fluxosModule } from './config/navigationConfig'

Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  barColor: '',
  barImage: '',
  drawer: null,
  selectedModule: fluxosModule,
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  },
  SET_BAR_IMAGE (state, payload) {
    state.barImage = payload
  },
  SET_DRAWER (state, payload) {
    state.drawer = payload
  },
  setSelectedModule (state) {
    state.selectedModule = fluxosModule
  },
  clearSelectedModule (state) {
    state.selectedModule = fluxosModule
  },
}

export default new Vuex.Store({
  state,
  mutations,
  modules: {
    auth,
  },
  actions: {
  },
})